module.exports = __webpack_public_path__ + "fonts/Noto_Sans_SC-300-63.5999c90.woff2";